import CONSTS from "../../../helpers/consts";
import METHODS from "../../../helpers/methods";

export const CS_POST_LOAD_MORE_SEARCH_RESULTS =
  "CS_POST_LOAD_MORE_SEARCH_RESULTS";
export const CS_POST_LOAD_MORE_SEARCH_RESULTS_SUCCESS =
  "CS_POST_LOAD_MORE_SEARCH_RESULTS_SUCCESS";
export const CS_CHANGE_SEARCH_AUDIENCE_FILTERS =
  "CS_CHANGE_SEARCH_AUDIENCE_FILTERS";
export const CS_SELECT_INFLUENCER = "CS_SELECT_INFLUENCER";
export const CS_SELECT_MULTIPLE_INFLUENCER = "CS_SELECT_MULTIPLE_INFLUENCER";
export const CS_CLEAR_ALL_SELECTED_USERS = "CS_CLEAR_ALL_SELECTED_USERS";
export const CS_ADD_TO_AUDIENCES_SUCCESS = "CS_ADD_TO_AUDIENCES_SUCCESS";
export const CS_ADD_TO_AUDIENCES_FAIL = "CS_ADD_TO_AUDIENCES_FAIL";
export const CS_GET_VELOCITY_SUMMARY_DATA = "CS_GET_VELOCITY_SUMMARY_DATA";
export const CS_GET_VELOCITY_SUMMARY_DATA_SUCCESS =
  "CS_GET_VELOCITY_SUMMARY_DATA_SUCCESS";
export const CS_CLEAR_VELOCITY_SUMMARY_DATA = "CS_CLEAR_VELOCITY_SUMMARY_DATA";
export const CS_SET_LIST_SOCIAL_PROVIDER = "CS_SET_LIST_SOCIAL_PROVIDER";
export const CS_POST_REFRESH_AUDIENCE = "CS_POST_REFRESH_AUDIENCE";
export const CS_POST_REFRESH_AUDIENCE_SUCCESS =
  "CS_POST_REFRESH_AUDIENCE_SUCCESS";
export const CS_CLOSE_TRIAL_EXCEEDED_CDT_MODAL =
  "CS_CLOSE_TRIAL_EXCEEDED_CDT_MODAL";
export const CS_DELETE_AWAITING_USER = "CS_DELETE_AWAITING_USER";
export const CS_SET_AUDIENCE_DATA = "CS_SET_AUDIENCE_DATA";
export const CS_SET_AUDIENCE_LOADING = "CS_SET_AUDIENCE_LOADING";
export const CS_SET_IS_INCORRECT_PROVIDER_ERROR =
  "CS_SET_IS_INCORRECT_PROVIDER_ERROR";
export const CS_CLEAR_AUDIENCE_DATA = "CS_CLEAR_AUDIENCE_DATA";
export const CS_SET_IS_AUDIENCE_DATA_ERROR = "CS_SET_IS_AUDIENCE_DATA_ERROR";
export const CS_SET_IS_ANALYZING_BRIEF = "CS_SET_IS_ANALYZING_BRIEF";
export const CS_GET_SETTINGS = "CS_GET_SETTINGS";
export const CS_GET_SETTINGS_SUCCESS = "CS_GET_SETTINGS_SUCCESS";
export const CS_TOGGLE_COLUMN_VISIBILITY = "CS_TOGGLE_COLUMN_VISIBILITY";
export const CS_SET_COLUMN_ORDER = "CS_SET_COLUMN_ORDER";
export const CS_MARK_CREATOR_AS_VIEWED = "CS_MARK_CREATOR_AS_VIEWED";
export const CS_MARK_CREATORS_IN_CAMPAIGN = "CS_MARK_CREATORS_IN_CAMPAIGN";

export function loadMoreSearchResults(data) {
  const url = CONSTS.creatorSearchByFilters;
  return {
    type: CS_POST_LOAD_MORE_SEARCH_RESULTS,
    payload: {
      request: {
        method: "post",
        url,
        headers: {
          "Workspace-Uuid": METHODS.getWorkspaceUuidFromCurrentUrl(),
        },
        data,
      },
    },
  };
}

export function refreshAudience(searchData, page = 1, sortBy) {
  return {
    type: CS_POST_REFRESH_AUDIENCE,
    payload: {
      audienceLoading: false,
      request: {
        method: "post",
        url: CONSTS.creatorSearchByFilters,
        data: {
          refresh: true,
          searchFilters: METHODS.mapCreatorSearchToRequest(searchData),
          pagination: {
            page: parseInt(page, 10),
            onPage: 20,
            orderBy: sortBy || "velocityIndex",
            order: "desc",
          },
        },
      },
    },
  };
}

export function changeSearchAudienceFilters(data) {
  return {
    type: CS_CHANGE_SEARCH_AUDIENCE_FILTERS,
    payload: { searchData: data },
  };
}

export function selectInfluencer(userId, profileUrl) {
  return {
    type: CS_SELECT_INFLUENCER,
    payload: { userId, profileUrl },
  };
}

export function selectMultipleInfluencer(userIds, profileUrls, value) {
  return {
    type: CS_SELECT_MULTIPLE_INFLUENCER,
    payload: { userIds, profileUrls, value },
  };
}

export function clearAllSelectedUsers() {
  return {
    type: CS_CLEAR_ALL_SELECTED_USERS,
  };
}

export function getVelocitySummaryData(userId, searchData) {
  return {
    type: CS_GET_VELOCITY_SUMMARY_DATA,
    payload: {
      request: {
        method: "post",
        url: CONSTS.getVelocitySummaryData,
        data: {
          userId,
          searchFilters: METHODS.mapCreatorSearchToRequest(searchData),
        },
      },
    },
  };
}

export function clearVelocitySummaryData() {
  return {
    type: CS_CLEAR_VELOCITY_SUMMARY_DATA,
  };
}

export function setAudienceLoading(isLoading) {
  return {
    type: CS_SET_AUDIENCE_LOADING,
    payload: { isLoading },
  };
}

export function setAudienceData(data) {
  return {
    type: CS_SET_AUDIENCE_DATA,
    payload: {
      data,
    },
  };
}

export function setIsIncorrectProviderError(isIncorrectProviderError) {
  return {
    type: CS_SET_IS_INCORRECT_PROVIDER_ERROR,
    payload: isIncorrectProviderError,
  };
}

export function clearAudienceData() {
  return {
    type: CS_CLEAR_AUDIENCE_DATA,
  };
}

export function setIsAudienceDataError(isAudienceDataError) {
  return {
    type: CS_SET_IS_AUDIENCE_DATA_ERROR,
    payload: { isAudienceDataError },
  };
}

export function getSettings(projectId) {
  return {
    type: CS_GET_SETTINGS,
    payload: {
      request: {
        url: CONSTS.getSettings,
        headers: {
          "Workspace-Uuid": METHODS.getWorkspaceUuidFromCurrentUrl(),
          ...(projectId ? { "Project-Uuid": projectId } : {}),
        },
      },
    },
  };
}

export function toggleColumnVisibility(key) {
  return {
    type: CS_TOGGLE_COLUMN_VISIBILITY,
    payload: { key },
  };
}

export function setColumnOrder(order) {
  return {
    type: CS_SET_COLUMN_ORDER,
    payload: { order },
  };
}

export function markCreatorAsViewed(hashUserId) {
  return {
    type: CS_MARK_CREATOR_AS_VIEWED,
    payload: { hashUserId },
  };
}

export function markCreatorsInCampaign(hashUserIds) {
  return {
    type: CS_MARK_CREATORS_IN_CAMPAIGN,
    payload: { hashUserIds },
  };
}
